import { useState } from 'react';
import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';
import { useCurrencyUnit} from 'hooks';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null); // usefull for export for future
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const currencyText = useCurrencyUnit()
  
  const [filters, setFilters] = useState([
    {
      title: 'محدوده تاریخ',
      label: {
        start: 'از تاریخ',
        end: 'تا تاریخ',
      },
      keyName: 'dateRangeDetail',
      id: {
        start: null,
        end: null,
      },
      value: {
        start: jMoment(new Date()).subtract(7, 'days'),
        end: jMoment(new Date()),
      },
      filterType: FILTER_TYPES.dateTimeRange,
      filterProps: {
        start: {},
        end: {},
      },
      disableDelete: true,
    },
    {
      title: 'محدوده‌ مبلغ مورد نظر',
      label: {
        start: 'از مبلغ',
        end: 'تا مبلغ',
      },
      keyName: 'priceRangeDetail',
      id: {
        start: 1695,
        end: 1696,
      },
      value: {
        start: null,
        end: null,
      },
      filterType: FILTER_TYPES.textRange,
      unit: currencyText,
      filterProps: {
        start: {
          currency: true,
        },
        end: {
          currency: true,
        },
      },
    },
    {
      title: 'نام کسب‌وکار',
      label: 'نام کسب‌وکار',
      keyName: 'bizNameDetail',
      id: 1704,
      value: null,
      filterType: FILTER_TYPES.text,
      filterProps: {},
    },
    {
      title: 'نام حساب تفصیلی کسب‌وکار',
      label: 'نام حساب تفصیلی کسب‌وکار',
      keyName: 'guildNameDetail',
      id: 1706,
      value: null,
      filterType: FILTER_TYPES.text,
      filterProps: {},
    },
  ]);

  return {
    setFilterParams,
    loading,
    setLoading,
    size,
    page, setPage,
    setSize,
    filters,
    setFilters,
  };
};

export default useCustomHook;
